/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SearchRouteImport } from './routes/search'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HelpRouteImport } from './routes/help'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as ConfirmationRouteImport } from './routes/confirmation'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CabinetIndexRouteImport } from './routes/cabinet.index'
import { Route as LegalSlugRouteImport } from './routes/legal.$slug'
import { Route as BookingTokenRouteImport } from './routes/booking.$token'
import { Route as BookHoldIdRouteImport } from './routes/book.$holdId'
import { Route as AuthMagicRouteImport } from './routes/auth.magic'
import { Route as ApartmentIdRouteImport } from './routes/apartment.$id'
import { Route as CabinetBookingsIdRouteImport } from './routes/cabinet.bookings.$id'

const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmationRoute = ConfirmationRouteImport.update({
  id: '/confirmation',
  path: '/confirmation',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CabinetIndexRoute = CabinetIndexRouteImport.update({
  id: '/cabinet/',
  path: '/cabinet/',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalSlugRoute = LegalSlugRouteImport.update({
  id: '/legal/$slug',
  path: '/legal/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingTokenRoute = BookingTokenRouteImport.update({
  id: '/booking/$token',
  path: '/booking/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BookHoldIdRoute = BookHoldIdRouteImport.update({
  id: '/book/$holdId',
  path: '/book/$holdId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMagicRoute = AuthMagicRouteImport.update({
  id: '/auth/magic',
  path: '/auth/magic',
  getParentRoute: () => rootRouteImport,
} as any)
const ApartmentIdRoute = ApartmentIdRouteImport.update({
  id: '/apartment/$id',
  path: '/apartment/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CabinetBookingsIdRoute = CabinetBookingsIdRouteImport.update({
  id: '/cabinet/bookings/$id',
  path: '/cabinet/bookings/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/confirmation': typeof ConfirmationRoute
  '/gallery': typeof GalleryRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/search': typeof SearchRoute
  '/apartment/$id': typeof ApartmentIdRoute
  '/auth/magic': typeof AuthMagicRoute
  '/book/$holdId': typeof BookHoldIdRoute
  '/booking/$token': typeof BookingTokenRoute
  '/legal/$slug': typeof LegalSlugRoute
  '/cabinet/': typeof CabinetIndexRoute
  '/cabinet/bookings/$id': typeof CabinetBookingsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/confirmation': typeof ConfirmationRoute
  '/gallery': typeof GalleryRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/search': typeof SearchRoute
  '/apartment/$id': typeof ApartmentIdRoute
  '/auth/magic': typeof AuthMagicRoute
  '/book/$holdId': typeof BookHoldIdRoute
  '/booking/$token': typeof BookingTokenRoute
  '/legal/$slug': typeof LegalSlugRoute
  '/cabinet': typeof CabinetIndexRoute
  '/cabinet/bookings/$id': typeof CabinetBookingsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/confirmation': typeof ConfirmationRoute
  '/gallery': typeof GalleryRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/search': typeof SearchRoute
  '/apartment/$id': typeof ApartmentIdRoute
  '/auth/magic': typeof AuthMagicRoute
  '/book/$holdId': typeof BookHoldIdRoute
  '/booking/$token': typeof BookingTokenRoute
  '/legal/$slug': typeof LegalSlugRoute
  '/cabinet/': typeof CabinetIndexRoute
  '/cabinet/bookings/$id': typeof CabinetBookingsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/confirmation'
    | '/gallery'
    | '/help'
    | '/login'
    | '/search'
    | '/apartment/$id'
    | '/auth/magic'
    | '/book/$holdId'
    | '/booking/$token'
    | '/legal/$slug'
    | '/cabinet/'
    | '/cabinet/bookings/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/confirmation'
    | '/gallery'
    | '/help'
    | '/login'
    | '/search'
    | '/apartment/$id'
    | '/auth/magic'
    | '/book/$holdId'
    | '/booking/$token'
    | '/legal/$slug'
    | '/cabinet'
    | '/cabinet/bookings/$id'
  id:
    | '__root__'
    | '/'
    | '/confirmation'
    | '/gallery'
    | '/help'
    | '/login'
    | '/search'
    | '/apartment/$id'
    | '/auth/magic'
    | '/book/$holdId'
    | '/booking/$token'
    | '/legal/$slug'
    | '/cabinet/'
    | '/cabinet/bookings/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConfirmationRoute: typeof ConfirmationRoute
  GalleryRoute: typeof GalleryRoute
  HelpRoute: typeof HelpRoute
  LoginRoute: typeof LoginRoute
  SearchRoute: typeof SearchRoute
  ApartmentIdRoute: typeof ApartmentIdRoute
  AuthMagicRoute: typeof AuthMagicRoute
  BookHoldIdRoute: typeof BookHoldIdRoute
  BookingTokenRoute: typeof BookingTokenRoute
  LegalSlugRoute: typeof LegalSlugRoute
  CabinetIndexRoute: typeof CabinetIndexRoute
  CabinetBookingsIdRoute: typeof CabinetBookingsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirmation': {
      id: '/confirmation'
      path: '/confirmation'
      fullPath: '/confirmation'
      preLoaderRoute: typeof ConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cabinet/': {
      id: '/cabinet/'
      path: '/cabinet'
      fullPath: '/cabinet/'
      preLoaderRoute: typeof CabinetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/$slug': {
      id: '/legal/$slug'
      path: '/legal/$slug'
      fullPath: '/legal/$slug'
      preLoaderRoute: typeof LegalSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/$token': {
      id: '/booking/$token'
      path: '/booking/$token'
      fullPath: '/booking/$token'
      preLoaderRoute: typeof BookingTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book/$holdId': {
      id: '/book/$holdId'
      path: '/book/$holdId'
      fullPath: '/book/$holdId'
      preLoaderRoute: typeof BookHoldIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/magic': {
      id: '/auth/magic'
      path: '/auth/magic'
      fullPath: '/auth/magic'
      preLoaderRoute: typeof AuthMagicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apartment/$id': {
      id: '/apartment/$id'
      path: '/apartment/$id'
      fullPath: '/apartment/$id'
      preLoaderRoute: typeof ApartmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cabinet/bookings/$id': {
      id: '/cabinet/bookings/$id'
      path: '/cabinet/bookings/$id'
      fullPath: '/cabinet/bookings/$id'
      preLoaderRoute: typeof CabinetBookingsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConfirmationRoute: ConfirmationRoute,
  GalleryRoute: GalleryRoute,
  HelpRoute: HelpRoute,
  LoginRoute: LoginRoute,
  SearchRoute: SearchRoute,
  ApartmentIdRoute: ApartmentIdRoute,
  AuthMagicRoute: AuthMagicRoute,
  BookHoldIdRoute: BookHoldIdRoute,
  BookingTokenRoute: BookingTokenRoute,
  LegalSlugRoute: LegalSlugRoute,
  CabinetIndexRoute: CabinetIndexRoute,
  CabinetBookingsIdRoute: CabinetBookingsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
